import React, { useState, useEffect } from "react";
import { FaBars, FaTimes, FaGithub, FaLinkedin } from "react-icons/fa";
import { Link } from "react-scroll";

const navLinks = [
  { label: "Home", to: "home" },
  { label: "Work", to: "work" },
  { label: "About", to: "about" },
  { label: "Skills", to: "skills" },
  { label: "Contact", to: "contact" },
];

const Navbar = () => {
  const [nav, setNav] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed w-full z-50 transition-all duration-300 bg-[#2F4156] ${
        scrolled ? "border-b border-[#567C8D]" : ""
      }`}
    >
      <div className="max-w-5xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="home" smooth duration={500} className="cursor-pointer">
          <span className="text-lg font-bold tracking-tight text-[#F5EFEB]">Jasper.</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map(({ label, to }) => (
            <Link
              key={to}
              to={to}
              smooth
              duration={500}
              className="text-sm text-[#C8D9E6] hover:text-[#F5EFEB] transition-colors cursor-pointer"
            >
              {label}
            </Link>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-4">
          <a href="https://www.linkedin.com/in/jasper-manalo-006207126/" target="_blank" rel="noreferrer"
            className="text-[#C8D9E6] hover:text-[#F5EFEB] transition-colors">
            <FaLinkedin size={20} />
          </a>
          <a href="https://github.com/jasper1001" target="_blank" rel="noreferrer"
            className="text-[#C8D9E6] hover:text-[#F5EFEB] transition-colors">
            <FaGithub size={20} />
          </a>
        </div>

        <button onClick={() => setNav(!nav)} className="md:hidden text-[#F5EFEB]">
          {nav ? <FaTimes size={20} /> : <FaBars size={20} />}
        </button>
      </div>

      {nav && (
        <div className="md:hidden bg-[#2F4156] border-t border-[#567C8D] px-6 py-6 flex flex-col gap-6">
          {navLinks.map(({ label, to }) => (
            <Link key={to} to={to} smooth duration={500} onClick={() => setNav(false)}
              className="text-xl font-medium text-[#F5EFEB] hover:text-[#C8D9E6] cursor-pointer">
              {label}
            </Link>
          ))}
          <div className="flex gap-4 pt-2">
            <a href="https://www.linkedin.com/in/jasper-manalo-006207126/" target="_blank" rel="noreferrer"
              className="text-[#C8D9E6] hover:text-[#F5EFEB]"><FaLinkedin size={22} /></a>
            <a href="https://github.com/jasper1001" target="_blank" rel="noreferrer"
              className="text-[#C8D9E6] hover:text-[#F5EFEB]"><FaGithub size={22} /></a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
